/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Limit} from '../models/Limit';
import type {UserLimitsRemoveRequest} from '../models/UserLimitsRemoveRequest';
import type {UserLimitsSaveRequest} from '../models/UserLimitsSaveRequest';

export interface GetUserMcpLimits$Request {
    userId: number;
}

export interface GetUserMcpLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserMcpLimitsRequest = createAction<PayloadData<void, GetUserMcpLimits$Request>>('USER_MCP_LIMITS__GET_USER_MCP_LIMITS__REQUEST');
export const getUserMcpLimitsSuccess = createAction<PayloadData<Array<Limit>, GetUserMcpLimits$Request>>('USER_MCP_LIMITS__GET_USER_MCP_LIMITS__SUCCESS');
export const getUserMcpLimitsFailure = createAction<PayloadData<Error, GetUserMcpLimits$Request, true>>('USER_MCP_LIMITS__GET_USER_MCP_LIMITS__FAILURE');

export const getUserMcpLimitsActions = [
    getUserMcpLimitsRequest,
    getUserMcpLimitsSuccess,
    getUserMcpLimitsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserMcpLimits = (meta: GetUserMcpLimits$Request, config?: GetUserMcpLimits$Config) => {
    return {
        CALL_API: {
            types: getUserMcpLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/mcp-limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RemoveUserMcpLimit$Request {
    userId: number;
    userLimitsRemoveRequest: UserLimitsRemoveRequest;
}

export interface RemoveUserMcpLimit$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeUserMcpLimitRequest = createAction<PayloadData<void, RemoveUserMcpLimit$Request>>('USER_MCP_LIMITS__REMOVE_USER_MCP_LIMIT__REQUEST');
export const removeUserMcpLimitSuccess = createAction<PayloadData<void, RemoveUserMcpLimit$Request>>('USER_MCP_LIMITS__REMOVE_USER_MCP_LIMIT__SUCCESS');
export const removeUserMcpLimitFailure = createAction<PayloadData<Error, RemoveUserMcpLimit$Request, true>>('USER_MCP_LIMITS__REMOVE_USER_MCP_LIMIT__FAILURE');

export const removeUserMcpLimitActions = [
    removeUserMcpLimitRequest,
    removeUserMcpLimitSuccess,
    removeUserMcpLimitFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserLimitsRemoveRequest} meta.userLimitsRemoveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeUserMcpLimit = (meta: RemoveUserMcpLimit$Request, config?: RemoveUserMcpLimit$Config) => {
    return {
        CALL_API: {
            types: removeUserMcpLimitActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/users/${meta.userId}/mcp-limits`,
            TRANSPORT_REQUEST_BODY: meta.userLimitsRemoveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveUserMcpLimit$Request {
    userId: number;
    userLimitsSaveRequest: UserLimitsSaveRequest;
}

export interface SaveUserMcpLimit$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveUserMcpLimitRequest = createAction<PayloadData<void, SaveUserMcpLimit$Request>>('USER_MCP_LIMITS__SAVE_USER_MCP_LIMIT__REQUEST');
export const saveUserMcpLimitSuccess = createAction<PayloadData<void, SaveUserMcpLimit$Request>>('USER_MCP_LIMITS__SAVE_USER_MCP_LIMIT__SUCCESS');
export const saveUserMcpLimitFailure = createAction<PayloadData<Error, SaveUserMcpLimit$Request, true>>('USER_MCP_LIMITS__SAVE_USER_MCP_LIMIT__FAILURE');

export const saveUserMcpLimitActions = [
    saveUserMcpLimitRequest,
    saveUserMcpLimitSuccess,
    saveUserMcpLimitFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserLimitsSaveRequest} meta.userLimitsSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveUserMcpLimit = (meta: SaveUserMcpLimit$Request, config?: SaveUserMcpLimit$Config) => {
    return {
        CALL_API: {
            types: saveUserMcpLimitActions,
            method: ApiMethods.PATCH,
            endpoint: `/web-api/users/${meta.userId}/mcp-limits`,
            TRANSPORT_REQUEST_BODY: meta.userLimitsSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

